import React, { useContext } from 'react';
// Components
import { FormattedHTMLMessage } from 'react-intl';
import FooterTranslate from './FooterTranslate/FooterTranslate';
import FooterLinks from './FooterLinks/FooterLinks';
import { StaticResource } from '../..';
// Config
import { ConfigContext } from '../../../providers';
// Styles
import styles from './footer.module.scss';
// Icons
import NgDpHorzIcon from '../../../assets/images/svg/ngdphorz';
import { getGlobalCssVariables } from '../../../helpers/general';
import { IRootState } from '../../../redux';
import { useSelector } from 'react-redux';
import { isMediaSizeLessThanXL } from '../../../helpers';

export const Footer = (): JSX.Element => {
    const config = useContext(ConfigContext);
    const { mediaSize } = useSelector(({ appReadouts }: IRootState) => ({
        mediaSize: appReadouts.mediaSize,
    }));
    const [colorWhite] = getGlobalCssVariables(['--color-white']);
    const role = '';

    return (
        <footer className={styles.footer} style={{ backgroundColor: config.colors.header.background }}>
            <div className="d-flex justify-content-between">
                <div className="d-flex">
                    <div tabIndex={0} role={role}>
                        <StaticResource
                            imageId={String(config.logos.footer.organizationLogo)}
                            className={styles.logo}
                            alt="LOGO"
                        />
                    </div>
                    <NgDpHorzIcon fill={colorWhite} />
                    {!isMediaSizeLessThanXL(mediaSize) && <FooterLinks isCentered isInline />}
                </div>

                <FooterTranslate />
            </div>

            {isMediaSizeLessThanXL(mediaSize) && <FooterLinks isCentered={false} isInline={false} />}

            <span tabIndex={0} role={role}>
                <FormattedHTMLMessage
                    id="COPYRIGHT_ALL_RIGHTS_RESERVED_EBOKS_IS_A_REGISTERED_TRADEMARK"
                    values={{
                        currentYear: new Date().getFullYear(),
                    }}
                />
            </span>
        </footer>
    );
};
